import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Trophy, Gamepad2, Ticket, User } from "lucide-react";
import { useI18n } from "../i18n";

const tabs = [
  { to: "/", label: "Home", icon: Home, end: true, id: "home" },
  { to: "/result", label: "Result", icon: Trophy, id: "result" },
  { to: "/play", label: "Royal Play", icon: Gamepad2, id: "royal_play" },
  { to: "/my-bets", label: "My Bets", icon: Ticket, id: "my_bets" },
  { to: "/me", label: "Me", icon: User, id: "me" },
];

export default function BottomNav() {
  const { t } = useI18n();
  return (
    <nav
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] rl-glass border-t border-slate-200 px-2 py-1.5 z-40 flex justify-between items-center"
      data-testid="bottom-nav"
    >
      {tabs.map((tab) => (
        <NavLink
          key={tab.id}
          to={tab.to}
          end={tab.end}
          data-testid={`nav-${tab.id}`}
          className={({ isActive }) =>
            `flex flex-col items-center justify-center flex-1 py-1 no-tap transition-colors ${
              isActive ? "text-blue-600" : "text-slate-500"
            }`
          }
        >
          {({ isActive }) => (
            <>
              <tab.icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 2} />
              <span className={`text-[10px] mt-0.5 ${isActive ? "font-semibold" : ""}`}>{t(tab.id)}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
